<template>
    <div class="text-center">
        <v-dialog v-model="dialog"
                  width="500">

            <v-card>
                <v-card-title class="text-h5 orange darken-2 white--text py-2">
                    Confirmar el cambio
                </v-card-title>

                <v-card-text>
                    <p class="mt-8 mb-0">
                        Al confirmar, el estudiante pasará de <b>Preinscrito</b> a <b>Inscrito</b> y se activará el <b>plan de pagos previamente generado.</b>
                    </p>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success"
                           outlined
                           @click="guardar()">
                        <v-icon small
                                left> mdi-check </v-icon>
                        confirmar
                    </v-btn>
                    <v-btn color="red"
                           outlined
                           @click="cerrar()">
                        <v-icon small
                                left> mdi-close </v-icon>
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            resolvePromise: null,
        };
    },
    methods: {
        openmodal() {
            this.dialog = true;
            return new Promise((resolve) => {
                this.resolvePromise = resolve;
            });
        },
        cerrar() {
            this.resolvePromise(false);
            this.dialog = false;
        },
        guardar() {
            this.resolvePromise(true);
            this.dialog = false;
        },
    },
};
</script>